import {isNotNil} from 'ramda';

import {getFinancialProductOffer} from 'features/financial-products';

import {PublicFinancialProductsResponseBody} from '../../../api/types/onlineOfferTypes';
import {
  FinancialProductPreferenceOutbox,
  FinancialProductPreferenceOutboxEntry,
} from '../FinancialProductPreferenceOutbox';

export const acknowledgesOutboxEntry = (
  products: PublicFinancialProductsResponseBody,
  entry: FinancialProductPreferenceOutboxEntry
) => {
  const selection = getFinancialProductOffer(products, entry.coordinates.productType)?.selection;

  return (
    products.selectedProduct === entry.coordinates.productType &&
    isNotNil(selection) &&
    FinancialProductPreferenceOutbox.matchesCoordinates(
      {...selection, productType: entry.coordinates.productType},
      entry.coordinates
    )
  );
};
